export const selectStyle = { width: 250 }